<template>
    <ul class="list-group list-group-hover list-group-striped">
      <!-- <containerSelection
        v-for="container in containersToday"
        v-bind:key="container.containerID"
        v-bind:containerID="container.containerID"
        v-bind:state="container.state"
        v-bind:shipowner="container.shipowner"
      ></containerSelection> -->
      <notification
          v-for="notification in notifications"
          v-bind:key="notification.id"
          v-bind:container="notification.container"
          v-bind:text="notification.text"
          v-bind:user="notification.user"
          v-bind:date="notification.date"
          v-bind:color="notification.color"        
      ></notification>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/components/notification.vue";
import {timestampToDate} from '@/services/helper'
import {getData} from '@/services/api'

export default {
  name: "notificationsList",
  components: {
    notification,
  },
  data() {
    return {
      notifications: [
        /*{
          id:"1",
          container: "MAEU 54934172 1",
          text: "ha registrado documento 'Bill of Landing'",
          user: "Consignatario 1",
          date: "18-07-2020",
          color: "#870091",
        },
        {
          id:"2",
          container: "MAEU 54934172 2",
          text: "el contenedor se ha ubicado en su posición asignada en terminal",
          user: "Notificación automática",
          date: "18-07-2020",
          color: "#32AC91",
        },
        {
          id:"3",
          container: "MAEU 54934172 3",
          text: "el contenedor ha entrado en las instalaciones.",
          user: "Notificación automática",
          date: "18-07-2020",
          color: "#32AC91",
        },
        {
          id:"4",
          container: "MAEU 54934172 4",
          text: "ha autorizado la entrada de mercancía peligrosa.",
          user: "Validador genérico",
          date: "18-07-2020",
          color: "#FFBCBC",
        },
        {
          id:"5",
          container: "MAEU 54934172 5",
          text: "ha registrado la documentación del expediente.",
          user: "Cargador 1",
          date: "18-07-2020",
          color: "#0EB2D4",
        },
        {
          id:"6",
          container: "MAEU 54934172 6",
          text: "ha reservado un espacio en un viaje.",
          user: "Consignatario 1",
          date: "18-07-2020",
          color: "#870091",
        },*/
        
      ],
    };
  },
  computed: {
    ...mapGetters("user", {
      authorized: "authorized",
    }),
    ...mapGetters("container", {
      container_id: "container_id",
    }),
  },
  mounted() {
    this.getNotifications()
  },
  methods: {
    getNotifications () {
      getData('events/?expediente='+this.container_id).then(res => {
        console.log('res.data', res.data)
        var events = res.data
        this.notifications = []
        events.forEach(event => {
          //var fecha = timestampToDate(event.iot.date)

          this.notifications.push({'date':'xx', 'user': 'El transitario','expediente': event.expediente, 'container':event.contenedor,'text': event.notificationMessage, color: "#870091"})
         
          // if(event.eventType == 'GEOFENCE_IN'){
          //   this.notifications.push({ 'date':fecha, 'user': 'El transitario','expediente': event.expediente, 'container':event.contenedor,'text': 'ha entrado en el puerto', color: "#0EB2D4"})
          // }else if (event.eventType == 'GEOFENCE_OUT') {
          //   this.notifications.push({'date':fecha, 'user': 'El transitario','expediente': event.expediente, 'container':event.contenedor,'text': 'ha salido del puerto', color: "#870091"})
          // }
        });
      
      })
    }
  },
};
</script>

<style lang= "scss" scoped>

</style>
